// @/services/app/content/modules/se-batch-invite.js

/**
 * SeBatchInviteHandler
 *
 * Provides locale-aware access to the SE batch invite dialog copy,
 * with an English fallback for any non-default locale.
 */
export class SeBatchInviteHandler {
  constructor(store) {
    this.store = store;
  }

  getContent(locale = 'en') {
    const localeContent = this.store.state.data.seBatchInvite?.[locale];
    if (localeContent) return localeContent;

    if (locale !== 'en') {
      return this.store.state.data.seBatchInvite?.['en'] || null;
    }

    return null;
  }
}
